var _defs, _g, _path, _circle, _ellipse, _circle2, _circle3, _path2, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSucceededPayment = function SvgSucceededPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1062.3 485.74"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#dee5f8;}.cls-3{fill:#1f3c88;}.cls-4{clip-path:url(#clippath-2);}.cls-5{opacity:.8;}.cls-6{clip-path:url(#clippath-6);}.cls-7{fill:#c18729;}.cls-8{opacity:.4;}.cls-9{clip-path:url(#clippath-7);}.cls-10{clip-path:url(#clippath-1);}.cls-11{clip-path:url(#clippath-4);}.cls-12{opacity:.3;}.cls-13{stroke:#ffd341;stroke-width:2px;}.cls-13,.cls-14,.cls-15{fill:none;}.cls-13,.cls-15{stroke-linecap:round;}.cls-16{clip-path:url(#clippath-9);}.cls-17{clip-path:url(#clippath);}.cls-18{fill:#ffd341;}.cls-19{fill:#102048;}.cls-20{clip-path:url(#clippath-3);}.cls-21{opacity:.1;}.cls-22{clip-path:url(#clippath-8);}.cls-23{clip-path:url(#clippath-5);}.cls-15{stroke:#c18729;stroke-linejoin:round;stroke-width:7px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 93.82,
    y: 0,
    width: 864.8,
    height: 407
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 93.82,
    y: 12.65,
    width: 882.24,
    height: 464.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 93.82,
    y: 12.65,
    width: 882.24,
    height: 464.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 104.41,
    y: 193.47,
    width: 838.53,
    height: 290.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 600.01,
    y: 274.41,
    width: 376.05,
    height: 190.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 93.82,
    y: 301.12,
    width: 378.23,
    height: 176.68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 680.86,
    y: 143.55,
    width: 87.78,
    height: 26.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 367.47,
    y: 206.42,
    width: 50.09,
    height: 21.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 404.2,
    y: 62.66,
    width: 68.2,
    height: 27.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 511.55,
    y: 324.6,
    width: 242.81,
    height: 149.06
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M923.93,320.38c-1.01-6.98,.82-14.06,5.06-19.69,10.62-14.08,15.79-30.77,13.33-47.77-5.7-39.4-50.2-65.48-99.39-58.24-33.01,4.86-59.73,23.48-72.02,47.11-4.7,9.32-14.57,14.88-24.97,14.07-3.96-.34-7.95-.22-11.88,.36-9.48,1.33-18.36,5.4-25.56,11.7-6.39,5.65-15.15,7.79-23.42,5.72-12.66-2.92-25.76-3.38-38.59-1.36-15.68,2.31-29.62,7.64-40.16,14.67-7.24,4.96-16.51,5.9-24.6,2.51-6.25-2.71-13.13-3.61-19.87-2.61-9,1.34-17.2,5.95-23.01,12.95-4.31,5.32-10.5,8.78-17.28,9.67-.33,.04-.66,.09-.99,.13-.74-.66-1.46-1.36-2.16-2.09-10.45-11.18-26.64-14.92-40.94-9.45-10.1,3.73-21.33,2.75-30.63-2.67-10.56-5.99-23.83-10.37-38.53-12.12-11.99-1.52-24.15-.99-35.96,1.58-10.37,2.44-21.28,.23-29.87-6.07-7.13-5.24-15.5-8.52-24.29-9.53-2.76-.33-5.54-.44-8.32-.34-12.97,.42-25.18-6.11-32.02-17.14-13.97-22.03-40.68-38.69-72.83-42.53-50.57-6.05-95.43,21.89-100.2,62.4-1.94,16.52,3.09,32.56,13.15,46.19,5.6,7.52,8.14,16.89,7.08,26.21l-6.52,55.4c-2.4,19.81,11.68,37.83,31.48,40.29l369.77,44.23c12.81,1.52,25.45-3.97,33.09-14.37l358.73-52.8c14.27-2.17,24.09-15.46,21.97-29.74l-9.65-66.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M975.98,324.94c-1.79-30.09-33.69-52.64-71.26-50.37-31.84,1.93-57.51,21.07-63.52,45.18-6.68-4.32-14.59-6.36-22.53-5.82-11.78,.71-21.85,6.59-27.46,14.91-9.63-6.06-23.91-9.43-39.62-8.48-17.59,1.06-32.76,7.3-41.29,15.86-9.73-12.04-27.38-13.91-39.42-4.18-2.94,2.37-5.36,5.31-7.13,8.65-8.62-.92-17.34-.15-25.68,2.24-25.02,6.98-41.76,25.6-37.37,41.58,2.96,10.8,14.82,17.63,29.91,18.77l3.68,61.92,327.71-19.83-4.75-79.77c12.38-10.7,19.64-25.17,18.71-40.67"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.82,355.04c.29-30.14,31.02-54.28,68.65-53.92,31.89,.31,58.49,18.12,65.69,41.9,6.46-4.65,14.25-7.09,22.21-6.95,11.81,.11,22.15,5.47,28.17,13.5,9.32-6.54,23.41-10.63,39.15-10.48,17.62,.17,33.08,5.63,42.03,13.75,9.1-12.52,26.63-15.29,39.15-6.18,3.05,2.22,5.63,5.04,7.57,8.28,8.57-1.35,17.31-1.03,25.76,.94,25.34,5.7,42.98,23.44,39.4,39.63-2.42,10.94-13.92,18.36-28.94,20.26l-.59,62.03-328.28-3.18,.76-79.91c-12.89-10.06-20.86-24.14-20.72-39.67"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M769.73,174.18c0,.87-.16,1.74-.48,2.56h-27.19s-.03-.04-.05-.06c0,.02,0,.04-.02,.06,0,0-.73,0-2.05,.02-13.46,.08-88.71,.5-88.71-.17,0-7.74,5.86-14,13.1-14,1.64,0,3.27,.32,4.79,.96,1.39-1.22,3.18-1.89,5.03-1.89,2.71,.03,5.21,1.43,6.65,3.73,.02-.04,.04-.08,.06-.12,1.64-3.22,4.35-5.77,7.67-7.21,3.06-1.41,6.39-2.14,9.77-2.11,1.02,0,2.04,.06,3.05,.19,3.69-7.6,11.35-12.46,19.79-12.58,10.94,0,20.06,8.34,22.09,19.4,1.25-.84,2.72-1.28,4.23-1.28,3.08,.04,5.86,1.85,7.16,4.64,1.41-.51,2.9-.77,4.41-.76,4.23,0,7.88,1.98,9.62,4.85,.7,1.14,1.08,2.45,1.09,3.79"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M768.65,170.38c-3.55-.78-7.19-1.07-10.81-.86l-24.29,.28c-9.7,.11-18.34-5.48-28.26-4.58-4.75,.44-9.59,2.4-14.15,2.67-3.62,.22-8.03-.43-10.26-2.64,1.64-3.22,4.35-5.77,7.67-7.21,3.06-1.41,6.39-2.14,9.77-2.11,1.02,0,2.04,.06,3.05,.19,3.69-7.6,11.35-12.47,19.79-12.58,10.94,0,20.06,8.34,22.09,19.4,1.25-.84,2.72-1.28,4.23-1.28,3.08,.04,5.86,1.85,7.16,4.64,1.41-.51,2.9-.77,4.41-.76,4.23,0,7.88,1.98,9.62,4.85"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M417.56,226.53c0,.57-.11,1.14-.32,1.68h-17.85s-.03-.02-.04-.04c0,.02,0,.03,0,.04s-59.59,.39-59.59-.1c0-5.08,3.84-9.19,8.6-9.19,1.08,0,2.15,.21,3.14,.63,.92-.79,2.09-1.23,3.3-1.24,1.78,.02,3.42,.94,4.37,2.44,1.29-2.87,4.41-5.09,8.3-5.87,1.05-.22,2.12-.33,3.19-.33,.67,0,1.34,.04,2,.12,2.42-4.99,7.45-8.19,12.99-8.26,7.18,0,13.17,5.48,14.51,12.73,.82-.55,1.79-.84,2.78-.84,2.02,.03,3.85,1.21,4.7,3.05,.93-.34,1.91-.51,2.9-.51,3.87,0,7.03,2.55,7.03,5.68"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.56,226.53c0,.57-.11,1.14-.32,1.68h-10.35c-.55-1.05-1.17-2.07-1.86-3.03-3.54-4.08-10.9-.81-15.16-4.09-.78-.59-1.4-1.38-2.21-1.92-2.48-1.66-5.77-.62-8.64,.17-2.94,.81-6.25,1.26-8.89-.28-1.47-.91-2.45-2.44-2.67-4.16,1.05-.22,2.12-.33,3.19-.33,.67,0,1.34,.04,2,.12,2.42-4.99,7.45-8.19,12.99-8.26,7.18,0,13.17,5.48,14.51,12.73,.82-.55,1.79-.84,2.78-.84,2.02,.03,3.85,1.21,4.7,3.05,.93-.34,1.91-.51,2.9-.51,3.87,0,7.03,2.55,7.03,5.68"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M473.61,94.67c0,.72-87.97,.14-87.97,.14,0-.01-.01-.03,0-.05-.02,.02-.04,.03-.06,.05h-26.35c-.3-.79-.46-1.63-.46-2.47,0-4.63,4.64-8.38,10.36-8.38,1.46,0,2.9,.24,4.28,.74,1.26-2.71,3.96-4.45,6.94-4.49,1.45,0,2.88,.43,4.09,1.24,1.97-10.72,10.82-18.79,21.42-18.79,.07,0,.15,0,.22,0,8.11,.19,15.42,4.9,18.96,12.19,.98-.13,1.97-.19,2.96-.19,7.86,0,14.55,3.82,16.95,9.15,1.4-2.22,3.82-3.57,6.44-3.6,1.79,0,3.53,.65,4.88,1.83,1.47-.62,3.05-.94,4.64-.93,5.04,.08,9.55,3.14,11.49,7.79,.8,1.82,1.21,3.79,1.21,5.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.4,88.9c-3.96,1.34-8.41,1.51-12.65,1.6-9.89,.22-20.4,.27-28.81-4.96-2.92-1.81-5.49-4.22-8.63-5.59-5.26-2.29-12.01-1.68-15.88-5.92-2.53-2.89-2.94-7.07-1.04-10.4,.2-.34,.43-.67,.69-.97,8.1,.19,15.42,4.89,18.96,12.19,.98-.13,1.97-.19,2.96-.19,7.86,0,14.55,3.82,16.95,9.15,1.4-2.22,3.82-3.57,6.44-3.6,1.79,0,3.53,.65,4.88,1.83,1.47-.62,3.05-.94,4.64-.93,5.04,.08,9.55,3.14,11.49,7.79"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M755.46,475.29l-352.94,1.84-80.86,.42,35.86-72.33,36.98-32.78,50.43-15.82,23.34-32.02h106.1l41.57,34.93,62.19,20.34,36.33,34.38,.86,1.29,39.03,58.11,1.09,1.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M754.36,473.67l-27.01-2.89-63.51-42.19-79.38-12.06-24.66-34.47-3.55-25.06-32.23-8.21-12.47-24.18h62.83l41.57,34.93,62.19,20.34,36.33,34.38,.86,1.29,39.03,58.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M469.78,378.1l-52.3,30.89-14.96,68.15-80.86,.42,35.86-72.33,36.98-32.78,50.43-15.82,23.34-32.02,1.5,53.49Z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1038.76,412.61c-1.25-5.1,1.02-10.27,6.27-14.37,13.15-10.27,19.56-22.45,16.52-34.86-7.06-28.75-62.18-47.78-123.11-42.5-40.88,3.54-73.98,17.14-89.2,34.38-6,6.8-18.07,10.93-30.93,10.27-4.9-.25-9.82-.16-14.71,.26-12.41,1.08-23.34,4.18-31.66,8.54-7.92,4.15-18.76,5.66-29.01,4.17-15.84-2.14-31.88-2.47-47.79-1-19.42,1.68-36.68,5.58-49.74,10.71-9.74,3.66-20.36,4.3-30.47,1.83-8.04-2-16.36-2.64-24.61-1.91-11.53,1-21.44,4.49-28.5,9.45-6.37,4.23-13.77,6.67-21.41,7.06-.41,.03-.82,.06-1.23,.09-.92-.48-1.81-.99-2.67-1.53-7.36-4.59-17.25-7.72-28.54-8.52-7.43-.54-14.9,0-22.17,1.62-12.6,2.72-25.69,2.05-37.94-1.95-13.08-4.37-29.52-7.56-47.73-8.85-14.85-1.11-29.77-.73-44.54,1.16-12.82,1.73-26.42,.21-37-4.43-9.57-4-19.74-6.35-30.09-6.95-3.49-.25-6.93-.32-10.31-.25-16.05,.37-31.01-4.47-39.66-12.51-17.31-16.08-50.39-28.23-90.21-31.04-62.64-4.41-118.2,15.97-124.1,45.53-2.41,12.05,3.83,23.76,16.29,33.71,6.89,5.5,10.13,12.32,8.77,19.13l-8.07-6.01c-2.9,14.52,14.56,27.68,38.99,29.4l458,32.28c16.41,1.16,31.77-3.15,40.98-10.49l444.33-38.53c17.6-1.53,29.79-11.24,27.22-21.7l-11.96-2.23Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 89,
    cy: 333,
    r: 89
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 519,
    cy: 234.5,
    rx: 62,
    ry: 61.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 974,
    cy: 320,
    r: 70
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 517.5,
    cy: 228.5,
    r: 61.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M498.65,231.5l14.27,12.23,28.83-33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 517.93,
    y1: 144.85,
    x2: 517.93,
    y2: 125.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 481,
    y1: 153.13,
    x2: 471.5,
    y2: 139.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 580.3,
    y1: 173.81,
    x2: 595.5,
    y2: 164.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 554.5,
    y1: 152.13,
    x2: 564,
    y2: 138.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 455.5,
    y1: 173.81,
    x2: 440.3,
    y2: 164.5
  })));
};
export default SvgSucceededPayment;